module.exports = __webpack_public_path__ + "img/gh.e4885587.svg";